export default __webpack_public_path__ + "static/media/order.c1b3dad5.png";